export default __webpack_public_path__ + "static/media/time-preview.60e366eb.png";